/*
 * Copyright (c) 2026 Paxia AI Pty Ltd. All rights reserved.
 * This software is proprietary and confidential.
 * No part of this codebase may be copied, modified, published, distributed, sublicensed, or used without prior written permission from Paxia AI Pty Ltd.
 */

import api from "./api";

const AI_BILLING_BASE = "/ai/expert/api/billing";

// ── Balance ──────────────────────────────────────────────────────────────
/** Get the user's AI credit balance and account settings. */
export const getAIBalance = (options = {}) =>
  api.get(`${AI_BILLING_BASE}/balance/`, options);

/** Update AI billing account settings (limits, auto-pause, etc.). */
export const updateAIBalance = (data) =>
  api.patch(`${AI_BILLING_BASE}/balance/`, data);

// ── Transactions ─────────────────────────────────────────────────────────
/**
 * Get paginated AI billing transactions.
 * @param {{ page?: number, page_size?: number, type?: string, start_date?: string, end_date?: string }} filters
 */
export const getAITransactions = (filters = {}) =>
  api.get(`${AI_BILLING_BASE}/transactions/`, { params: filters });

/** Get spending summary for last N days. */
export const getAISpendingSummary = (days = 30, options = {}) =>
  api.get(`${AI_BILLING_BASE}/transactions/summary/`, { params: { days }, ...options });

// ── Credits ──────────────────────────────────────────────────────────────
/**
 * Top up AI credits (instant or via payment gateway).
 * @param {{ amount?: number, package_id?: string, gateway?: string, success_url?: string, cancel_url?: string }} data
 */
export const topUpAICredits = (data) =>
  api.post(`${AI_BILLING_BASE}/credits/topup/`, data);

/** Get available credit packages. */
export const getAICreditPackages = () =>
  api.get(`${AI_BILLING_BASE}/packages/`);

// ── Usage ────────────────────────────────────────────────────────────────
/** Get AI usage breakdown by system/expert/agent. */
export const getAIUsage = (days = 30) =>
  api.get(`${AI_BILLING_BASE}/usage/`, { params: { days } });

/** Get chart-ready AI usage analytics for the billing usage page. */
export const getAIUsageAnalytics = (filters = {}) =>
  api.get(`${AI_BILLING_BASE}/usage/analytics/`, { params: filters });

/** Get drill-down rows for a selected billing usage contributor. */
export const getAIUsageDrilldown = (filters = {}) =>
  api.get(`${AI_BILLING_BASE}/usage/drilldown/`, { params: filters });
